/**
 * exercise-parts-steps.js
 */

import React from 'react';
import TourStep from '../tour-step';
import tourStepProps from '../tour-step-props';


export default [
  {
    target: "[data-testid='exercise-tablist']",
    title: "Exercise Details and Dog Completions",
    ...tourStepProps,
    placementBeacon: 'left',
    spotlightPadding: 0,
    isFixed: true,
    content: (
      <TourStep>
        There are two parts to consider when recording a training exercise:
        <ol>
          <li>The exercise <strong>Details</strong> describe what will be done</li>
          <li>The <strong>Dog Completion</strong> describes how each of your dog(s) performed</li>
        </ol>
      </TourStep>
    ),
  },
  {
    target: "[data-testid='exercise-tablist'] a:first-child",
    title: "Exercise Details",
    ...tourStepProps,
    isFixed: true,
    content: (
      <TourStep>
        You're on the <strong>Details</strong> tab right now.
        This is where you'll describe what will be done in the exercise.
        All handlers with dogs at this event will share the same exercise details.
      </TourStep>
    ),
  },
  {
    target: "[data-testid='exercise-tablist'] a:nth-child(2)",
    title: "Dog Completion",
    ...tourStepProps,
    isFixed: true,
    content: (
      <TourStep>
        Fill out the <strong>Dog Completion</strong> tab(s) when the exercise is over.
        You'll describe how each of your dogs performed in that exercise.
        This information is specific to you and your dogs and isn't shared with other handlers.
      </TourStep>
    ),
  },
];
